import React, { useEffect, useRef, useState } from "react";
import { Modal, Select } from "antd";
import { Button, Form, Input, notification } from "antd";
import { POST, PUT, COMPRESS_IMAGE, GET } from "../../utils/apiCalls";
import API from "../../config/API";
import TextArea from "antd/es/input/TextArea";
import ImagePicker from "../components/ImagePicker";
import Cropper, { ReactCropperElement } from "react-cropper";
import useFetch from "../../shared/hook/fetchData";

import "cropperjs/dist/cropper.css";
import moment from "moment";
const update = "update";
const TypeModal = (props: any) => {
  const [form] = Form.useForm();
  const [Notifications, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [image, setImage] = useState<any>({});
  const type = props?.type;
  const fileInputRef = useRef(null);
  //   const { data: subcategory, isLoading: loading1 } = useFetch(
  //     API.SUB_CATEGORY,
  //     false
  //   );

  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const cropperRef = useRef<ReactCropperElement>(null);
  const [aspectRatio, setAspectRatio] = useState(1 / 1);

  const [Loading, setLoading] = useState(true);
  useEffect(() => {
    subcategory();
  }, []);

  useEffect(() => {
    if (type === update) {
      form.setFieldsValue({
        name: props?.data?.name,
        image: props?.data?.image,
        description: props?.data?.description,
      });
    } else {
      form.resetFields();
    }
  }, [props?.data, type]);
  const formSubmitHandler = async (values: any) => {
    setIsLoading(true);
    try {
      let imageUrl = props?.data?.image;
      if (croppedImage) {
        const ImageBlob = await fetch(croppedImage).then((r) => r.blob());
        let name = moment(new Date()).unix();
        let file = new File([ImageBlob], name + "N.jpg");
        imageUrl = await COMPRESS_IMAGE(file);
      }
      const obj = {
        name: values?.name?.trim(),
        image: imageUrl.url,
        subCategory: values?.subCategory,
        description: values?.description?.trim(),
      };
      const responseimg: any =
        type === update
          ? await PUT(API.UPDATE_TYPE + props?.data?._id, obj)
          : await POST(API.CREATE_TYPE, obj);
      if (responseimg?.status) {
        Notifications["success"]({
          message: "Success",
          description: `Successfully ${type === update ? "Updated" : "Added"}`,
        });
        form.resetFields();
        props?.modalClose();
        props?.getCategory();
        setImage({});
        setCroppedImage(null);
      } else {
        Notifications["error"]({
          message: `Failed to ${type === update ? "Update" : "Add New item"}`,
          description: responseimg.message,
        });
      }
    } catch (err: any) {
      Notifications["error"]({
        message: `Failed to ${type == update ? "Update" : "Add New item"}`,
        description: err.message,
      });
    }
    setIsLoading(false);
  };
  const handleCrop = async () => {
    if (cropperRef.current) {
      const canvas: HTMLCanvasElement | null =
        cropperRef.current.cropper.getCroppedCanvas({
          fillColor: "#fff",
        });
      if (canvas) {
        const croppedData = canvas.toDataURL("image/jpeg");
        setCroppedImage(croppedData);
        setCropModalOpen(false);
        try {
        } catch (error) {
          console.error("Form validation failed:", error);
        }
      }
    }
  };

  const subcategory = async () => {
    try {
      const url = `${API.SUB_CATEGORY}?order=ASC&page=1&take=50`;
      const response: any = await GET(url, null);
      if (response) setData(response.data);
      else setData([]);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`${type == update ? "Update" : "Add New"} Category`}
      open={props?.open}
      okText="Update"
      centered
      cancelButtonProps={{ style: { display: "none" } }}
      okButtonProps={{ style: { display: "none" } }}
      onCancel={() => {
        props?.modalClose();
        setImage({});
        setCropModalOpen(false);
      }}
    >
      {contextHolder}
      <Form
        form={form}
        style={{ maxWidth: 600 }}
        layout="vertical"
        onFinish={formSubmitHandler}
      >
        {cropModalOpen ? (
          <div className="mt-2">
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={(e) => {
                const selectedFile = e.target.files?.[0];
                if (selectedFile) {
                  setImage({
                    file: selectedFile,
                    url: URL.createObjectURL(selectedFile),
                  });
                  setCropModalOpen(true);
                }
              }}
            />
            <Cropper
              ref={cropperRef as React.RefObject<ReactCropperElement>}
              src={image?.url}
              style={{ height: 400, width: "100%" }}
              aspectRatio={aspectRatio}
              guides={true}
            />
            <div style={{ textAlign: "center", marginTop: 16 }}>
              <Button type="primary" onClick={handleCrop}>
                Crop Image
              </Button>
              <Button
                style={{ marginLeft: 16 }}
                onClick={() => {
                  if (fileInputRef.current) {
                    (fileInputRef.current as any).click();
                  }
                }}
              >
                Choose Another Image
              </Button>
            </div>
          </div>
        ) : (
          <Form.Item
            label="Image"
            name="image"
            rules={[
              {
                required: true,
                message: "Please Upload image",
              },
            ]}
          >
            <ImagePicker
              onChange={(file: any) => {
                setImage(file);
                setCropModalOpen(true);
              }}
              fileURL={
                image?.url
                  ? image.url
                  : type == update
                  ? props?.data?.image
                  : null
              }
            />
          </Form.Item>
        )}
        <Form.Item
          label="Name"
          name={"name"}
          rules={[
            {
              required: true,
              message: "Please Enter Name",
            },
          ]}
        >
          <Input placeholder="Type Name" />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[
            {
              required: true,
              message: "Please Enter Description",
            },
          ]}
        >
          <TextArea rows={4} placeholder="Description" />
        </Form.Item>
        <Form.Item name="subCategory">
          <Select
            bordered={false}
            style={{ width: "100%" }}
            className="border rounded"
            allowClear
            placeholder={"Select SubCategory"}
          >
            {data?.map((item: any, index: number) => (
              <Select.Option key={item._id} value={item._id}>
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {cropModalOpen ? null : (
          <div className="d-flex gap-2 justify-content-end">
            <Button
              onClick={() => {
                props?.modalClose();
                setImage({});
              }}
            >
              Cancel
            </Button>
            <Button type="primary" loading={isLoading} onClick={form.submit}>
              {type == update ? "Update" : "Add"}
            </Button>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default TypeModal;
